import styled from 'styled-components';
import { spacer4 } from '@spotify-internal/encore-foundation';
import IconArrowTopRight from "../Icon/IconArrowTopRight";
export default styled(IconArrowTopRight).attrs({
  iconSize: 16
}).withConfig({
  displayName: "IconExternal",
  componentId: "sc-10dozbc-0"
})(["margin-left:", ";"], spacer4);